<template>
  <div class="container pt-5">
    <div class="account-box">
      <div class="account-wrapper">
        <h3 class="account-title">Class Booking System</h3>
        <hr />
        <form @submit.prevent="login">
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <!-- USER TYPE -->
          <div class="form-group">
            <label>Log in as</label>
            <select class="form-control" v-model="userType" required>
              <option value>-- Please Select --</option>
              <option :value="userTypeInstructor">Staff</option>
              <option :value="userTypeStudent">{{ userTypeStudent }}</option>
            </select>
          </div>
          <!-- /USER TYPE -->

          <!-- SCHOOL CODE -->
          <div class="form-group">
            <label>School Code</label>
            <input
              class="form-control"
              type="text"
              v-model="schoolCode"
              maxlength="20"
              required
            />
          </div>
          <!-- /SCHOOL CODE -->

          <!-- ID -->
          <div class="form-group">
            <label>ID</label>
            <input
              class="form-control"
              type="text"
              v-model="username"
              maxlength="50"
              required
            />
          </div>
          <!-- /ID -->

          <!-- PASSWORD -->
          <div class="form-group">
            <label>Password</label>
            <input
              class="form-control"
              type="password"
              v-model="password"
              maxlength="50"
              required
              autocomplete="off"
            />
          </div>
          <!-- /PASSWORD -->

          <!-- BUTTON -->
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Sign In
            </button>
          </div>
          <div class="form-group text-center mb-1">
            <router-link :to="{ name: 'schoolUserForgotPassword' }">
              Forgot password?
            </router-link>
          </div>
          <!-- /BUTTON -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      errorMessage: "",
      userType: "",
      schoolCode: "",
      username: "",
      password: "",
      //to track class booking confirmation request
      fromRoute: null,
    };
  },
  methods: {
    login() {
      this.errorMessage = "";
      this.$store.state.isLoading = true;
      API.schoolUser
        .login({
          UserType: this.userType,
          SchoolCode: this.schoolCode,
          UserName: this.username,
          Password: this.password,
        })
        .then((response) => {
          this.$store.state.isLoading = false;
          let success = response.data.success;
          if (success) {
            let data = response.data.data;
            localStorage.setItem("cbstoken", JSON.stringify(data));

            //redirection
            if (this.fromRoute.name == "classBookingRequest") {
              this.$router.replace({
                name: this.fromRoute.name,
                params: { id: this.fromRoute.params.id },
              });
            } else {
              let userType = data.UserType;
              if (
                userType == this.userTypeSchoolAdmin ||
                userType == this.userTypeInstructorSchoolAdmin
              ) {
                this.$router.replace({ name: "schoolAdminInstructorList" });
              } else if (userType == this.userTypeInstructor) {
                this.$router.replace({ name: "instructorMySchedule" });
              } else if (userType == this.userTypeStudent) {
                this.$router.replace({ name: "studentClassBookingForm" });
              } else {
                this.$router.replace({ name: "otherMyCalendar" });
              }
            }
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.errorMessage = error;
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
    });
  },
  created() {
    if (this.$route.path.includes("/classbookingrequest")) {
      this.$router.replace({
        name: "classBookingRequest",
        params: { id: this.$route.params.id },
      });
    } else {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      if (data) {
        API.schoolUser
          .verifySchoolUserToken({ Token: data.Token })
          .then((response) => {
            if (response.data == false) {
              localStorage.removeItem("cbstoken");
            } else {
              let userType = data.UserType;
              if (userType == this.userTypeMainAdmin) {
                this.$router.replace({ name: "schoolList" });
              } else if (
                userType == this.userTypeSchoolAdmin ||
                userType == this.userTypeInstructorSchoolAdmin
              ) {
                this.$router.replace({ name: "schoolAdminInstructorList" });
              } else if (userType == this.userTypeInstructor) {
                this.$router.replace({ name: "instructorMySchedule" });
              } else if (userType == this.userTypeStudent) {
                this.$router.replace({ name: "studentClassBookingForm" });
              } else {
                this.$router.replace({ name: "otherMyCalendar" });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  },
};
</script>

<style scoped>
.container {
  background: url("/static/bg-image.jpg") no-repeat center fixed;
  background-size: cover;
  -webkit-background-size: cover;
  max-width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SchoolUser/Login.vue